import React from "react";
import styled from "styled-components";
import Container from "../styles/Container";
const FooterStyled = styled.footer`
  background: var(--black);
  padding: 4rem 0;
`;
const FooterText = styled.p`
  color: var(--white);
  margin: 0;
`;
export default function Footer() {
  return (
    <FooterStyled>
      <Container>
        <FooterText>
          {" "}
          © {new Date().getFullYear()} Your Business. All rights reserved.
        </FooterText>
      </Container>
    </FooterStyled>
  );
}
